










































































import { Component, Prop } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import ContactProfileDto from '@/models/Contacts/ContactProfileDto';


@Component({
  name: 'ContactProfileSummary',
  components: { }
})
export default class extends GiganautVue {

    @Prop({required: true})
    contactProfile: ContactProfileDto
}
